<template>
  <CHeader fixed style="background-color:#2E2E2E;border-color:#2E2E2E;">
        <div v-if="!user" style="text-align: center; width: 100%; padding: 8px;">
            <img src="/img/logo_white.png" @click="signOut()"/>
        </div>
        <div v-else class="row" style="width: 100%">
          <ul class="c-header-nav">
            <li class="c-header-nav-item px-4"> 
              <CHeaderNavLink to="/">
                <div class="c-avatar" style="width: 100%;" >
                    <img src="/img/logo_white.png"/>
                </div>
              </CHeaderNavLink>
            </li>
          </ul>

          <ul class="c-header-nav mfs-auto"></ul>
              <CHeaderNav class="ml-5">
                <CHeaderNavItem >
                        <CHeaderNavLink to="/">
                          <div class="c-avatar">
                          <span v-if="user&&user.profilePicId">
                            <img class="c-avatar-img"
                              :src="process.env.VUE_APP_API_MEDIA_FILE_BASE_URL + user.profilePicId"
                            />
                          </span>
                          <span v-else>
                            <img src="/img/user.svg" class="c-avatar-img" />
                          </span>
                        </div>
                </CHeaderNavLink>
              </CHeaderNavItem>
              <CHeaderNavItem class="px-2">
                  <CDropdown
                    v-bind:toggler-text="user.firstName" 
                    class="m-2 header-dropdown"
                  >
                    <CDropdownItem @click="signOut()">Logout</CDropdownItem>
                  </CDropdown>
              </CHeaderNavItem>
            </CHeaderNav>
          </div>

    <Loading :active.sync="isLoading" 
        color="#F3756B"
        background-color="#000"
        :opacity="0.9"
        loader="spinner"
        :is-full-page="true">
    </Loading>
  </CHeader>
</template>

<script>
// import { mapActions } from "vuex";
import Loading from 'vue-loading-overlay';

export default {
  name: 'TheDarkHeader',
  components: {
    Loading,
  },
  data () {
    return {
      isLoading:false,
    }
  },
  computed : {
    user() {
      return this.$store.state.auth.loginData;
    },
  },
  methods : {
    signOut(){
      this.isLoading = true;
      this.$store.dispatch('auth/signOut');
    },
    // ...mapActions("auth", ["signOut"])
  }

}
</script>
 
 <style>
  .header-dropdown .btn.dropdown-toggle:focus {
    outline: none !important;
    box-shadow: none !important;
  }

  .header-dropdown .btn.dropdown-toggle {
    color: #C1C1C1; 
    font-size: 15px; 
    padding: 0;
  }
 </style>